import { Button, Flex, Skeleton, Typography, theme } from "antd";
import { useEffect, useState } from "react";
import { ModalPostNew } from "../timeline/ModalPostNew";

const { Text, Title, Link } = Typography;
const { useToken } = theme;

export function DashboardKnow() {
  const { token } = useToken();
  const [isLoading, setLoading] = useState<boolean>(true);
  const [randomFact, setRandomFact] = useState<{ text: string }>();
  const [isAddingToTimeline, setAddingToTimeline] = useState<boolean>(false);

  useEffect(() => {
    // Useless random fact
    setTimeout(() => {
      fetch("https://uselessfacts.jsph.pl/api/v2/facts/random")
        .then((data) => data.json())
        .then((data) => {
          setRandomFact(data);
          setLoading(false);
        });
    }, 1000);
  }, []);

  return (
    <>
      {isAddingToTimeline && (
        <ModalPostNew
          onClose={() => setAddingToTimeline(false)}
          onCreate={() => {}}
          suggest={{
            text: randomFact?.text,
          }}
        />
      )}
      <Flex
        align="flex-start"
        style={{
          flexDirection: "column",
          width: "100%",
          maxHeight: "100%",
          borderRadius: token.borderRadiusLG,
          // backgroundColor: token.colorBgContainer,
          backdropFilter: "blur(20px)",
          border: `2px solid ${token.colorBorderSecondary}`,
          padding: token.paddingMD,
        }}
      >
        <Flex
          align="center"
          justify="space-between"
          style={{
            width: "100%",
            marginBottom: token.marginMD,
          }}
        >
          <Flex align="center">
            {/* <Avatar
              size={24}
              src="https://picsum.photos/800"
              style={{
                marginRight: "5px",
              }}
            /> */}

            <Text
              style={{
                fontSize: token.fontSizeHeading4,
                fontWeight: token.fontWeightStrong,
                color: token.colorTextHeading,
              }}
            >
              Did you know?
            </Text>
          </Flex>

          <Button
            style={{
              boxShadow: `0px 1px 2px 0px ${token.Button?.defaultShadow}`,
            }}
            onClick={() => {
              setLoading(true);
              fetch("https://uselessfacts.jsph.pl/api/v2/facts/random")
                .then((data) => data.json())
                .then((data) => {
                  setRandomFact(data);
                  setLoading(false);
                });
            }}
          >
            Next
          </Button>
        </Flex>

        <Flex
          style={{
            width: "100%",
            height: "100%",
            flexDirection: "column",
          }}
        >
          {!isLoading && (
            <Flex
              style={{
                width: "100%",
                flexDirection: "column",
                borderRadius: token.borderRadius,
                // background: token.colorBgContainer,
                backdropFilter: "blur(20px)",
              }}
            >
              {/* <img
                src="https://picsum.photos/800"
                style={{
                  height: "160px",
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              /> */}

              {/* <Text
                style={{
                  fontSize: token.fontSizeHeading4,
                  lineHeight: token.lineHeightHeading4,
                  color: token.colorTextHeading,
                  fontWeight: token.fontWeightStrong,
                  marginTop: token.marginMD,
                }}
              >
                Random title for "Did you know?"
              </Text> */}
              <Text
                style={{
                  fontSize: token.fontSizeLG,
                  lineHeight: token.lineHeightLG,
                  color: token.colorTextSecondary,
                  // margin: `${token.marginMD}px 0`,
                  marginBottom: token.marginMD,
                }}
              >
                {randomFact?.text}
              </Text>

              <Flex justify="end">
                <Button
                  type="primary"
                  style={{ width: "fit-content" }}
                  onClick={() => setAddingToTimeline(true)}
                >
                  Add to Timeline
                </Button>
              </Flex>
            </Flex>
          )}
          {isLoading && (
            <Flex
              style={{
                width: "100%",
                flexDirection: "column",
                borderRadius: token.borderRadius,
                background: token.colorBgContainer,
              }}
            >
              <Skeleton.Image
                active
                style={{
                  width: "100%",
                  height: "160px",
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              />
              <Skeleton
                active
                style={{
                  margin: `${token.marginMD}px 0`,
                }}
              />
              <Skeleton.Button active />
            </Flex>
          )}
        </Flex>
      </Flex>
    </>
  );
}
